export interface ThreadMarkSummary {
  has_on_air?: boolean | number | null
  hasOnAir?: boolean | number | null
  has_flagged?: boolean | number | null
  hasFlagged?: boolean | number | null
  latest_on_air_message_id?: number | null
  latestOnAirMessageId?: number | null
  latest_flagged_message_id?: number | null
  latestFlaggedMessageId?: number | null
}

const toBoolean = (value: boolean | number | null | undefined): boolean => {
  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value === 'number') {
    return value === 1
  }

  return false
}

const toMessageId = (value: number | null | undefined): number | null => {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value
  }

  return null
}

export function hasOnAir(thread: ThreadMarkSummary | null | undefined): boolean {
  if (!thread) {
    return false
  }

  return toBoolean(thread.hasOnAir ?? thread.has_on_air ?? null)
}

export function hasFlagged(thread: ThreadMarkSummary | null | undefined): boolean {
  if (!thread) {
    return false
  }

  return toBoolean(thread.hasFlagged ?? thread.has_flagged ?? null)
}

export function latestOnAirMessageId(
  thread: ThreadMarkSummary | null | undefined,
): number | null {
  if (!thread) {
    return null
  }

  return toMessageId(thread.latestOnAirMessageId ?? thread.latest_on_air_message_id ?? null)
}

export function latestFlaggedMessageId(
  thread: ThreadMarkSummary | null | undefined,
): number | null {
  if (!thread) {
    return null
  }

  return toMessageId(thread.latestFlaggedMessageId ?? thread.latest_flagged_message_id ?? null)
}

export function latestMarkedMessageId(
  kind: 'onAir' | 'flagged',
  thread: ThreadMarkSummary | null | undefined,
): number | null {
  return kind === 'onAir'
    ? latestOnAirMessageId(thread)
    : latestFlaggedMessageId(thread)
}

export function hasMarked(kind: 'onAir' | 'flagged', thread: ThreadMarkSummary | null | undefined): boolean {
  return kind === 'onAir' ? hasOnAir(thread) : hasFlagged(thread)
}
